module.exports = __webpack_public_path__ + "img/instagram.3f5e6b3b.png";